<div class="promotion-content">
  <div>
    <p>
      {{ promotion?.msg }}
    </p>
  </div>
</div>
